import { Handle } from "react-flow-renderer";
import styled, { css } from "styled-components";

export const ConditionalEndStyle = styled.div`
  width: 43px;
  height: 43px;
  box-shadow: 0 0 0 1.2px #42464c;
  cursor: auto;
  box-sizing: border-box;
  border-radius: 2px;
  transform: rotate(-45deg);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  &.critical {
    border: 4px solid #d93333 !important;
  }

  ${({ status }) =>
    status === "doing"
      ? css`
          background-color: #f9e169;
        `
      : status === "pending"
      ? css`
          background-color: #fff;
        `
      : status === "done"
      ? css`
          background-color: #a0f69e;
        `
      : null}
`;

export const HandleStyle = styled(Handle)`
  width: 8px;
  height: 8px;
`;

export const ConditionalEndStyleInside = styled.div`
  width: 35px;
  height: 35px;
  box-sizing: border-box;
  border-radius: 2px;
  box-shadow: 0 0 0 0.8px #42464c;
  display: flex;
  justify-content: center;
  align-items: center;
`;
